import tw from "twin.macro";

import { BaseButton } from "../../shared/components/BaseButton";

export const DropdownButton = tw(BaseButton)`
  bg-gray
  border-none
  px-3 py-1
`;
